import React from "react";

import FooterItem from "@/react-components/FooterItem";
import { routerEnum } from "@/utils/enum";
import config from "@/utils/config";

class LPFooter extends React.Component {
  render() {
    const router = config.router();
    return (
      <footer className="lp-footer-container">
        <div className="flex-row lp-footer-container-link">
          {router
            .filter(
              (item) =>
                item.type === routerEnum.footer && item.notAuthentication
            )
            .map((item, index) => (
              <FooterItem key={index} item={item} />
            ))}
        </div>
        <div className="lp-footer-container-copyright">
          COPYRIGHT © NOMURA SECURITIES CO., LTD. ALL RIGHTS RESERVED
        </div>
      </footer>
    );
  }
}

export default LPFooter;
